import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, brl, formatApiError } from "@/lib/api";
import { PageHead, Stat, RangePicker, Empty, monthStartIso, todayIso, fmtDate } from "@/components/erp/ErpUi";
import { OUT_STATUS } from "@/components/Outsourced";
import { toast } from "sonner";
import { Handshake, Loader2 } from "lucide-react";

export default function OwnerOutsourced() {
  const [range, setRange] = useState([monthStartIso(), todayIso()]);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/outsourced/report", { params: { from: range[0], to: range[1] } }).then(({ data }) => setData(data)).catch((e) => toast.error(formatApiError(e)));
  }, [range]);
  const t = data?.totals || {};
  return (
    <div className="space-y-5 animate-fade-up" data-testid="outsourced-page">
      <PageHead icon={Handshake} kicker="Financeiro" title="Terceirizados"><RangePicker from={range[0]} to={range[1]} onChange={setRange} testid="out-range" /></PageHead>
      {!data ? <Loader2 className="h-6 w-6 animate-spin text-green-brand mx-auto" /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Stat testid="out-count" label="Serviços" value={t.count} />
            <Stat testid="out-total" label="Total" value={brl(t.total)} />
            <Stat testid="out-paid" label="Pago" value={brl(t.paid)} tone="green" />
            <Stat testid="out-open" label="Em aberto" value={brl(t.open)} tone="red" />
          </div>
          {!data.partners.length ? <Empty>Nenhum serviço terceirizado no período.</Empty> : (
            <section className="rounded-2xl border border-zinc-800 overflow-x-auto">
              <table className="w-full text-sm min-w-[520px]" data-testid="out-partners-table">
                <thead><tr className="bg-zinc-900 text-[11px] font-mono-caps text-zinc-500 uppercase"><th className="text-left px-3 py-2">Parceiro</th><th className="text-right px-3 py-2">Serviços</th><th className="text-right px-3 py-2">Fora agora</th><th className="text-right px-3 py-2">Total</th><th className="text-right px-3 py-2">Pago</th><th className="text-right px-3 py-2">Em aberto</th></tr></thead>
                <tbody>{data.partners.map((p) => (
                  <tr key={p.partner_id} data-testid={`out-partner-${p.partner_id}`} className="border-t border-zinc-800"><td className="px-3 py-2 text-zinc-100">{p.partner_name}</td><td className="px-3 py-2 text-right">{p.count}</td><td className="px-3 py-2 text-right">{p.away}</td><td className="px-3 py-2 text-right">{brl(p.total)}</td><td className="px-3 py-2 text-right text-green-neon">{brl(p.paid)}</td><td className="px-3 py-2 text-right text-red-300 font-bold">{brl(p.open)}</td></tr>
                ))}</tbody>
              </table>
            </section>
          )}
          {!!data.services.length && (
            <section className="space-y-2" data-testid="out-services">
              <h2 className="text-sm font-bold uppercase text-zinc-400">Serviços no período</h2>
              {data.services.map((s) => (
                <Link key={s.id} to={`/owner/ordens/${s.order_id}`} className="flex items-center justify-between gap-2 rounded-lg border border-zinc-800 p-3 text-sm hover:border-green-brand">
                  <span className="min-w-0 truncate text-zinc-100">{s.plate || "—"} · OS #{s.order_number || "—"} · {s.description} <span className="text-zinc-500">({s.partner_name})</span></span>
                  <span className="shrink-0 text-xs text-zinc-400">{OUT_STATUS[s.status]} · {fmtDate(s.sent_at)} · {brl(s.cost)} · {s.payable_status === "pago" ? "pago" : "aberto"}</span>
                </Link>
              ))}
            </section>
          )}
        </>
      )}
    </div>
  );
}
